var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('spinner',{staticClass:"mx-auto mb-2"}),_vm._v(" "),_c('img',{attrs:{"src":_vm.$widgetConfig.companyLogo,"width":"150","alt":"Data Axle USA"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }